/**
 * Size enum for components with variants, like Container.
 */
enum Size {
	xs = "xs",
	sm = "sm",
	md = "md",
	lg = "lg",
	xl = "xl",
	xxl = "xxl",
}

export default Size;
